import { useMemo } from 'react';
import type { Option } from 'components/atoms/select';
import { useTranslate } from 'hooks/use-translation';

export const TIMESHEET_ADMIN_ID = -1;
export const useAdminOption = (): Option => {
  const translate = useTranslate();

  return useMemo(
    () =>
      ({
        label: translate('settings.timesheets.controls.approvals.admin'),
        value: TIMESHEET_ADMIN_ID,
      } as Option),
    [translate],
  );
};
